import { useQuery } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';

export function useUsers(currentUserId, blockedIds = []) {
  return useQuery({
    queryKey: ['users', currentUserId, blockedIds],
    queryFn: async () => {
      const [usersResult, friendshipsResult] = await Promise.all([
        supabase
          .from('profiles')
          .select('*')
          .neq('id', currentUserId)
          // RLS 已對一般使用者隱藏未完成 onboarding 的檔案；
          // 這裡再過濾一次，讓 admin 帳號的探索頁與一般使用者一致
          .eq('is_onboarded', true)
          .or('is_social_enabled.eq.true,is_social_enabled.is.null'),
        supabase
          .from('friendships')
          .select('id, user_id, friend_id, status')
          .or(`user_id.eq.${currentUserId},friend_id.eq.${currentUserId}`)
      ]);

      if (usersResult.error) throw usersResult.error;
      if (friendshipsResult.error) throw friendshipsResult.error;

      const users = (usersResult.data || [])
        .filter(u => u.name && (u.birthday || u.age) && !blockedIds.includes(u.id))
        .map(p => ({ _id: p.id, profile: p }));

      const friendships = (friendshipsResult.data || []).map(f => ({
        _id: f.id,
        user: { _id: f.user_id },
        friend: { _id: f.friend_id },
        status: f.status
      }));

      return { users, friendships };
    },
    enabled: !!currentUserId,
  });
}
